import type { FC, ReactNode } from 'react';
import { createContext, useMemo } from 'react';

import { RootStore } from './RootStore';
import type { Configuration } from '~/models/configuration';

export const StoreContext = createContext<RootStore | null>(null);

StoreContext.displayName = 'RootStore';

interface StoreProviderProps {
  children: ReactNode;
  configuration: Configuration;
}

export const StoreProvider: FC<StoreProviderProps> = ({ children, configuration }) => {
  const value = useMemo(() => new RootStore(configuration), [configuration]);

  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
};
